export const SIZING_KIT_DISCOUNT = '79JQ1Z2WW13E';
